import React from "react";
import Sidebar from "../../../components/sidebar";
import Header from "../../../components/header";
import { useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import API_BASE_URL from "../../../config";
import TestTable from "../../../components/admin/master/testTable";
import { authFetch } from "../../../utility/authFetch";

function Test() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(0);
  const [name, setName] = useState("");
  const [rate, setRate] = useState("");
  const [category, setCategory] = useState("");
  const [location, setLocation] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);
    const url = editMode
      ? `${API_BASE_URL}/api/edit-test-master`
      : `${API_BASE_URL}/api/test-master`;

    if (editMode) {
      formData.append("ID", editId);
    }

    const method = editMode ? "PUT" : "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert(
          editMode ? "Test updated successfully" : "Test added successfully"
        );
        formRef.current.reset();
        setIsSubmitting(false);
        setName("");
        setRate("");
        setCategory("");
        setLocation("");
        setEditMode(false);
        setLoader(false);
        setEditId(null);
        setReload((prev) => prev + 1);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  const handleEdit = (item) => {
    setName(item.name);
    setRate(item.rate);
    setCategory(item.category);
    setLocation(item.location);
    setEditMode(true);
    setEditId(item.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">Test Master</h5>
            <Form onSubmit={handleSubmit} ref={formRef}>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formTestName">
                    <Form.Label>
                      Test Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Test Name"
                      name="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                      autoComplete="off"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formCategory">
                    <Form.Label>
                      Category <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      aria-label="Category"
                      name="category"
                      required
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                    >
                      <option value="Orthopedic">Orthopedic</option>
                      <option value="Gynecology">Gynecology</option>
                      <option value="Both">Both</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formRate">
                    <Form.Label>
                      Rate <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Rate"
                      name="rate"
                      value={rate}
                      onChange={(e) => setRate(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formLocation">
                    <Form.Label>
                      Location <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      aria-label="location"
                      name="location"
                      required
                      value={location}
                      onChange={(e) => setLocation(e.target.value)}
                    >
                      <option value="InHouse">InHouse</option>
                      <option value="OutHouse">OutHouse</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {editMode ? "UPDATE" : "SUBMIT"}
              </Button>
            </Form>
          </div>

          <div className="container bg-white p-4 rounded shadow-sm mt-4">
            <h5 className="mb-3">Test List</h5>
            <TestTable onEdit={handleEdit} reload={reload} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Test;
